import script from "./AuditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditPage.vue?vue&type=script&setup=true&lang=js"

import "./AuditPage.vue?vue&type=style&index=0&id=97e6a6ea&lang=css"

const __exports__ = script;

export default __exports__